import React from 'react';
import Box from '@mui/material/Box';

export default function SalesTableBody(props) {
  const { children } = props;

  return <Box>{children}</Box>;
}
